/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PermalinkViewContainer_story = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_story" | "ReplyListContainer1_story" | "CreateCommentMutation_story" | "CreateCommentReplyMutation_story">;
    readonly " $refType": "PermalinkViewContainer_story";
};
export type PermalinkViewContainer_story$data = PermalinkViewContainer_story;
export type PermalinkViewContainer_story$key = {
    readonly " $data"?: PermalinkViewContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"PermalinkViewContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermalinkViewContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationThreadContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentMutation_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentReplyMutation_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '0ba512bd5ae1de2dbedec526c0b9ae02';
export default node;
